import { Grid, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PhoneField from "../../../../common/components/functional/phoneField/PhoneField";

const RecommenderForm = () => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {/* Name */}
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("recommenders:name")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="name"
          control={control}
          rules={{ required: true }}
          render={({ field: { name, value, onChange } }) => (
            <Grid item container xs={9}>
              <TextField
                name={name}
                value={value}
                onChange={onChange}
                error={!!errors.name}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </Grid>
          )}
        />
      </Grid>
      {/* Title */}
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("recommenders:title")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="title"
          control={control}
          rules={{ required: true }}
          render={({ field: { name, value, onChange } }) => (
            <Grid item container xs={9}>
              <TextField
                name={name}
                value={value}
                onChange={onChange}
                error={!!errors.title}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </Grid>
          )}
        />
      </Grid>
      {/* Company */}
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("recommenders:company")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="company"
          control={control}
          rules={{ required: true }}
          render={({ field: { name, value, onChange } }) => (
            <Grid item container xs={9}>
              <TextField
                name={name}
                value={value}
                onChange={onChange}
                error={!!errors.company}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </Grid>
          )}
        />
      </Grid>
      {/* Phone */}
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("recommenders:phone")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="phone"
          control={control}
          render={({ field: { value, onChange } }) => (
            <Grid item container xs={9}>
              <PhoneField value={value} onChange={onChange} />
            </Grid>
          )}
        />
      </Grid>
      {/* Email */}
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("recommenders:email")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="email"
          control={control}
          render={({ field: { name, value, onChange } }) => (
            <Grid item container xs={9}>
              <TextField
                name={name}
                value={value}
                onChange={onChange}
                error={!!errors.email}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </Grid>
          )}
        />
      </Grid>
      {/* Additional info */}
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("recommenders:additionalInfo")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="additionalInfo"
          control={control}
          render={({ field: { name, value, onChange } }) => (
            <Grid item container xs={9}>
              <TextField
                name={name}
                value={value}
                onChange={onChange}
                error={!!errors.additionalInfo}
                autoComplete="off"
                size="small"
                fullWidth
                multiline
                maxRows={10}
              />
            </Grid>
          )}
        />
      </Grid>
    </>
  );
};

export default RecommenderForm;
